<template>
    <div class="div-info-account">
        <v-card dark :color="COLOR.CLICK_MENU_COLOR" class="">
            <v-card-text class="px-2white--text text-center">
                <v-layout align-center row class="pa-0">
                    <v-flex md7>
                        <h3 class="text-color">Số tiền hiện có :</h3>
                    </v-flex>
                    <v-flex md5>
                        <h3 class="text-color">{{ balanceCurrent | currency}}</h3>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>

        <v-card dark :color="COLOR.CLICK_MENU_COLOR" class="mt-8">
            <v-card-text class="px-2white--text text-center">
                <v-layout align-center row class="pa-0">
                    <v-flex md7>
                        <h3 class="text-color">Số tiền đã nạp :</h3>
                    </v-flex>
                    <v-flex md5>
                        <h3 class="text-color">{{ balanceWithdraw | currency}}</h3>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>

        <v-card color="" class="mt-8">
            <v-card-text class="px-2 text-center black--text">
                <v-flex md12>
                <p class="info-account">
                    <span class="font-weight-bold">Hướng dẫn nạp tiền:</span><br><br>
                    Hướng dẫn nạp tiền<br>
                    {{ bank_name }}<br>
                    Hệ thống thanh toán sẽ cộng tiền tự động qua {{ bank_name }}<br>

                    Tỷ giá: 1 VND = 1 {{ coin_name }}<br>
                    Các bạn chú ý chuyển khoản đúng cú pháp thì sẽ được tự động nạp tiền nếu sai cú pháp sẽ phải nạp bằng tay và bạn sẽ bị trừ 10 % tiền nạp.
                    Ưu tiên chuyển khoản qua NGÂN HÀNG hệ thống sẽ chuyển nhanh hơn. <br>
                    Bạn nên chọn chuyển tiền nhanh 24/7  trong trường hợp chuyển khoản từ NGÂN HÀNG khác thì mới nhận đc tiền luôn ko thì phải mất 1 ngày NGÂN HÀNG mới duyệt tiền. <br><br>
                    <span class="font-weight-bold">*** Chú ý ***</span><br><br>
                    - Buổi tối 18-24h {{ bank_name }} thường tổng kết các giao dịch trong ngày nên thường chậm và lag <br>
                    - Do đó chuyển khoản vào thời gian này có thể bị auto nạp chậm, sau vài tiếng mới nhận được tiền <br>
                    - Các bạn nên ưu tiên chuyển vào ban ngày để nhận tiền nhanh nhất nhé

                </p>
                </v-flex>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
    import { COLOR } from "~/config/constant";
    import {CONFIG_PAGE} from "../../store/actions.type";
    export default {
        name: "attention",
        data() {
            return {
                // Color chinh
                COLOR: COLOR,
                // balanceCurrent: 0,
                // balanceWithdraw: 86868000,
                currentUser: [],
                coin_name: 'coin',
                bank_name: 'Vietcombank'
            }
        },
        props: {
            balanceCurrent: Number,
            balanceWithdraw: Number
        },
        methods: {
             configPage(){
                 this.$store.dispatch(CONFIG_PAGE).then((data) => {
                     let coin_name = data.filter(o => o.key == 'key_cp_content_coin_name');
                     if(coin_name[0]['value'] != undefined && coin_name[0]['value'] != '' && coin_name[0]['status']){
                         this.coin_name = coin_name[0]['value'];
                     }

                     let bank_accounts = data.filter(o => o.key == 'key_cp_bank_accounts');
                     if(bank_accounts[0]['value'] != undefined && bank_accounts[0]['value'] != '' && bank_accounts[0]['status']){
                         if(bank_accounts[0]['value'][0].bank_name != undefined && bank_accounts[0]['value'][0].bank_name != ''){
                             this.bank_name = bank_accounts[0]['value'][0].bank_name;
                         }
                     }
                });
            },
        },
        mounted() {
            this.configPage();
        }
    }
</script>

<style lang="scss">
    @import "../../scss/main";
    .text-color-btn {
        color: $clickMenuColor;
    }

</style>
